import { render } from "./ModalAceitarJustificativa.vue?vue&type=template&id=b3386f9e"
import script from "./ModalAceitarJustificativa.vue?vue&type=script&lang=js"
export * from "./ModalAceitarJustificativa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__